/***
 * Created on 2023/10/18
 * @author: Adam Cheng <adamcheng@qnap.com>
 ***/

import React from 'react';
import {useTranslation} from "react-i18next";

function EmailActivation() {
    const { t } = useTranslation();

    const email = () => {
        const data = sessionStorage.getItem('signup_data');
        if (data) {
            const signup = JSON.parse(data);
            return signup?.qid || signup?.email;
        }
        return '';
    }

    return (
        <section className="common-page-wrapper">
            <div className="common-page-header">{t('@Sent activation email successfully@')}</div>
            <div className="common-page-body">
                <p>{t('@The activation email has been sent to@')}
                    <span className="font-semibold pl-4 pr-4">{email()}</span>
                </p>
                <p>{t('@Please check your email to activate myQNAPcloud account, and then you can sign in again.@')}</p>
                <div>
                    <ul className="list-style-type-disc ml-16">
                        <li className="pl-4">
                            {t('@If you have not received the activation mail, please check the spam folder in your mail client first. We suggest to add myQNAPcloud announce email account no-reply@qnap.com to your contact list to avoid the email accidentally diverted to your spam folder.@')}
                        </li>
                    </ul>
                </div>
                <br/>
                <p className="mt16 !mb-10"><a href={`/signup?qid=${email()}#send_activation_email`}>{t('@Have not received activation email?@')}</a></p>
                <p><a href={`/signin?qid=${email()}`}>{t('@Already have an account?@')}</a></p>
            </div>
        </section>
    );
}

export default EmailActivation;